/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import logo from '../assets/logo.png'

const FooterComponent = () => {
  const date = new Date().getFullYear()

  console.log(date)

  return (
    <footer>
      {/* Footer Start*/}
      <div className="footer-area">
        <div className="container">
          <div className="footer-top footer-padding">
            <div className="row justify-content-between">
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                <div className="single-footer-caption mb-50">
                  <div className="single-footer-caption mb-30">
                    {/* logo */}
                    <div className="footer-logo">
                      <a href="index.html">
                        <img
                          src={logo}
                          alt="logo eggless"
                          style={{ width: '120px' }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4>Services</h4>
                    <ul>
                      <li>
                        <a href="#">Digital Aggency</a>
                      </li>
                      <li>
                        <a href="#">Product</a>
                      </li>
                      <li>
                        <a href="/content">Content</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4>Customer Care</h4>
                    <ul>
                      <li>
                        <a href="/contact">Contact Us</a>
                      </li>
                      <li>
                        <a href="/about">About Us</a>
                      </li>
                      <li>
                        <a href="#">News &amp; Articles</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4>
                      <span>+62</span> 82111908780
                    </h4>
                    <ul>
                      <li>
                        <a href="mailto:dev.eggless@gmail.com">
                          dev.eggless@gmail.com
                        </a>
                      </li>
                    </ul>
                    <p>
                      Kelapa Dua Residance, C 03. Jl. Tugu Raya, Tugu, Kec.
                      Cimanggis, Kota Depok, Jawa Barat 16451
                    </p>
                  </div>
                  {/* footer social */}
                  <div className="footer-social">
                    <a href="https://www.youtube.com/channel/UCYjhMXDnujBM4Gz_E0jzUDg">
                      <i className="fab fa-youtube" />
                    </a>
                    <a href="https://www.instagram.com/eggless.dev/">
                      <i className="fab fa-instagram" />
                    </a>
                    <a href="https://wa.me/6282111908780">
                      <i className="fab fa-whatsapp" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="row">
              <div className="col-xl-12 ">
                <div className="footer-copy-right">
                  <p>Copyright &copy; {date} All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End*/}
    </footer>
  )
}

export default FooterComponent
